<template>
  <section class="features">
    <div class="container"
         style="background: white;padding: 15px;margin-top: 15px;display: flex;flex-direction: column;text-align: left;overflow-y: auto">
      <div class="publishjob">发布职位</div>
      <div class="top">
        <div style="color: #101010;font-size: 16px">已为您智能生成职位，可直接发布</div>
        <div class="label"><span>{{ this.citySelect }}</span> | <span>{{ this.selectedJob }}</span></div>
      </div>
      <div class="content">
        <div class="contentItem">
          <img src="https://www.mgadmob.com/mp/icon/ic_must.png" style="width: 10px;height: 10px">
          <div class="contenttitle">职位标题</div>
          <Input v-model="selectedJob" placeholder="请输入职位标题" clearable :maxlength="120">
          </Input>
        </div>
        <div class="contentItem">
          <img src="https://www.mgadmob.com/mp/icon/ic_must.png" style="width: 10px;height: 10px">
          <div class="contenttitle">薪资</div>
          <Input type="number" v-model="salary" placeholder="请输入薪资" clearable :maxlength="120"
                 style="flex: 1 1 auto;">
          </Input>
          <Select v-model="salaryUnit" style="margin-left: 10px;width: 150px">
            <Option v-for="item in optionList" :key="item" :value="item">
              {{ item }}
            </Option>
          </Select>
        </div>
        <CustomGridView style="margin-bottom: 5px;margin-left: 15%" :items="gridItems"
                        :selected-index="selecteIndex" @itemClick="onGridItemClick" :columns="5"/>
        <div class="contentItem">
          <img src="https://www.mgadmob.com/mp/icon/ic_must.png" style="width: 10px;height: 10px">
          <div class="contenttitle">职位描述</div>
          <Input type="textarea" v-model="jobDesc" placeholder="请输入职位描述" clearable :maxlength="500">
          </Input>
        </div>
        <div class="contentItem">
          <img src="https://www.mgadmob.com/mp/icon/ic_must.png" style="width: 10px;height: 10px">
          <div class="contenttitle">招聘人数</div>
          <Input type="number" v-model="jobNumber" placeholder="请输入招聘人数" clearable :maxlength="120">
          </Input>
        </div>
        <div class="contentItem">
          <img src="https://www.mgadmob.com/mp/icon/ic_must.png" style="width: 10px;height: 10px">
          <div class="contenttitle">手机号</div>
          <Input type="number" v-model="phone" placeholder="请输入手机号" clearable :maxlength="120">
          </Input>
        </div>
        <div class="contentItem">
          <img src="https://www.mgadmob.com/mp/icon/ic_must.png" style="width: 10px;height: 10px">
          <div class="contenttitle">招聘企业</div>
          <a @click="addLicense()" v-if="companyInfo == null">点击上传营业执照</a>
          <div v-else style="display: flex;flex-direction: row;align-items: center">
            <span style="font-size: 16px;color: black">{{ companyInfo.company }}</span>
            <div style="font-size: 12px;color: black">(如需要为其他企业招聘,请<a class="tips-class" @click="contactBD()">联系商务</a>)
            </div>
          </div>
        </div>
        <div class="contentItem">
          <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
            <div style="display: flex;flex-direction: row;align-items: center;">
              <img src="https://www.mgadmob.com/mp/icon/ic_must.png" style="width: 10px;height: 10px">
              <div class="contenttitle">报名二维码</div>
            </div>
            <div style="color: #9A9A9A;font-size: 10px;margin-top: 8px">(请上传微信二维码)</div>
          </div>
          <a style="width:60px;height: 60px;background-color: #F7F7F7;position: relative;margin-left: 10px">
            <img class="child" style="width:60px;height: 60px" :src="codeUrl"></img>
            <Upload :action="uploadFile" name="file" :on-success="uploadCallback"
                    :data="uploadData" accept="image/*" :show-upload-list="false">
              <div class="child" style="width: 100%;display: flex;flex-direction: column;">
                <div style="font-size: 25px;">+</div>
                <div style="font-size: 11px;">选择图片</div>
              </div>
            </Upload>
          </a>
        </div>
      </div>
      <div class="bottom">
        <a class="bottombtn" style="margin-right: 10px;" @click="preClick()">上一步</a>
        <a class="bottombtn" style="margin-left: 10px" @click="nextClick()">下一步</a>
      </div>
      <AddLicenseDialog
        :visible.sync="showAddLicenseDialog"
        width="450px"
        @confirm="confirm"
      />
      <CenterDialog
        :visible.sync="showQrCode"
        type="image"
        width="350px"
        :image="imageQrcode"
        :showActions="false"
      />
    </div>
  </section>
</template>

<script>
import CustomGridView from "@/views/toc/custom-grid-view-simple.vue";
import AddLicenseDialog from "@/views/toc/AddLicenseDialog.vue";
import api from "@/api";
import CenterDialog from "@/views/toc/ShowImageDialog.vue";

export default {
  name: 'PostJobStep1',
  components: {CenterDialog, AddLicenseDialog, CustomGridView},
  created() {
    this.jobId = this.$route.params.jobId;
    //传了 jobId 进来，表示是编辑模式
    if (this.jobId != null && this.jobId != undefined) {
      this.getBusinessPublishJob(this.jobId);
    } else {
      this.citySelect = this.$route.params.citySelect
      this.areaSelect = this.$route.params.areaSelect
      this.selectedJob = this.$route.params.selectedJob
      this.address = this.$route.params.address
      this.jobDescId = this.$route.params.selectedJobId
      if (this.jobDescId) {
        this.getJdTemplate(this.jobDescId)
      }
    }
    this.getSalaryUnitList()
    this.getCompanyInfo()
  },
  data() {
    return {
      jobId : null,
      citySelect: null,
      areaSelect: null,
      selectedJob: null,
      address: null,
      jobDescId: null,
      jobDesc: null,
      jobNumber: null,
      salary: null,
      phone: null,
      optionList: [],
      salaryUnit: null,
      companyInfo: null,
      paramsQQ: null,
      selecteIndex: 0,
      showAddLicenseDialog: false,
      showQrCode: false,
      codeUrl : null,
      imageQrcode: "https://www.mgadmob.com/mp/img/postImage.png",
      gridItems: [{
        title: '日结',
        textColor: '#555555',
        textColorSelected: '#26B399',
        bgColor: '#F7F7F7',
        bgColorSelected: '#E8FDF9',
        borderColor: '#F7F7F7',
        borderColorSelect: '#20DDD2',
      },
        {
          title: '周结',
          textColor: '#555555',
          textColorSelected: '#26B399',
          bgColor: '#F7F7F7',
          bgColorSelected: '#E8FDF9',
          borderColor: '#F7F7F7',
          borderColorSelect: '#20DDD2',
        },
        {
          title: '月结',
          textColor: '#555555',
          textColorSelected: '#26B399',
          bgColor: '#F7F7F7',
          bgColorSelected: '#E8FDF9',
          borderColor: '#F7F7F7',
          borderColorSelect: '#20DDD2',
        },
        {
          title: '完工结',
          textColor: '#555555',
          textColorSelected: '#26B399',
          bgColor: '#F7F7F7',
          bgColorSelected: '#E8FDF9',
          borderColor: '#F7F7F7',
          borderColorSelect: '#20DDD2',
        },
        {
          title: '面议',
          textColor: '#555555',
          textColorSelected: '#26B399',
          bgColor: '#F7F7F7',
          bgColorSelected: '#E8FDF9',
          borderColor: '#F7F7F7',
          borderColorSelect: '#20DDD2',
        }
      ],
      uploadFile: api.statistics.uploadFileToc,
      uploadData: {filePath: 'img'},
    }
  },
  methods: {
    getSalaryUnitList() {
      api.statistics
        .getSalaryUnitList()
        .then(res => {
          if (res.code == 2000) {
            for (let i = 0; i < res.data.length; i++) {
              let item = res.data[i]
              this.optionList.push(item.salaryUnit)
              this.salaryUnit = this.optionList[0]
            }
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    getJdTemplate(id) {
      api.statistics
        .getJobTemplate(id)
        .then(res => {
          if (res.code == 2000) {
            this.jobDesc = res.data
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    getBusinessPublishJob(id) {
      api.statistics
        .getBusinessPublishJob(id)
        .then(res => {
          if (res.code == 2000) {
            this.selectedJob = res.data.jobCategory
            this.citySelect = res.data.city
            this.areaSelect = res.data.area
            this.address = res.data.address
            this.jobNumber = res.data.jobNumber
            this.jobDesc = res.data.jobDesc
            this.salary = res.data.salary
            this.salaryUnit = res.data.salaryUnit
            this.codeUrl = res.data.codeUrl
            //设置选中的结算方式
            for (let i = 0; i < this.gridItems.length; i++){
              if(this.gridItems[i].title == res.data.payMethod){
                this.selecteIndex = i
                break
              }
            }
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    onGridItemClick(index) {
      this.selecteIndex = index
    },
    preClick() {
      if (this.jobId == null) {
        this.$router.replace({name: 'postjobstep1'})
      } else {
        this.$router.replace({path: 'positionlist'})
      }
    },
    confirm(data) {
      this.companyInfo = {
        company: data.company,
        id: data.companyId
      }
    },
    nextClick() {
      if (this.selectCity === null) {
        this.$Message.error('请选择城市')
        return
      }
      if (this.address === null || this.address.trimEnd() === '') {
        this.$Message.error('请输入详细地址')
        return
      }
      if (this.selectedJob == null) {
        this.$Message.error('请填写职位标题')
        return
      }
      if (this.salary == null) {
        this.$Message.error('请填写薪资')
        return
      }
      if (this.jobDesc == null) {
        this.$Message.error('请填写职位描述')
        return
      }
      if (this.jobNumber == null) {
        this.$Message.error('请填写招聘人数')
        return
      }
      if (this.phone == null) {
        this.$Message.error('请填写手机号')
        return
      }
      if (!this.util.checkPhone(this.phone)) {
        this.$Message.error('请填写正确格式的手机号')
        return;
      }
      if (this.companyInfo == null) {
        this.$Message.error('请先上传营业执照')
        return
      }
      if (this.codeUrl == null) {
        this.$Message.error('请上传二维码图片')
        return
      }
      this.paramsQQ = {
        id: this.jobId,
        address: this.address,
        area: this.areaSelect,
        city: this.citySelect,
        company: this.companyInfo.company,
        companyId: this.companyInfo.id,
        isAuth: true,
        jobCategory: this.selectedJob,
        jobDesc: this.jobDesc,
        jobNumber: this.jobNumber,
        payMethod: this.gridItems[this.selecteIndex].title,
        salary: this.salary,
        salaryUnit: this.salaryUnit,
        title: this.selectedJob,
        secondTagId: this.jobDescId,
        codeUrl: this.codeUrl
      }
      api.statistics
        .saveJobInfo(this.paramsQQ)
        .then(res => {
          if (res.code == 2000) {
            if (res.data.success != true) {
              this.$Message.error("职位发布失败，请稍后重试")
              return
            }
            if (res.data.vipCheckResult.needPay == true) {
              if (res.data.vipCheckResult.needPayReason == 1 || res.data.vipCheckResult.needPayReason == 2) {
                this.$router.replace({path: 'positionlist'})
                // this.$router.replace({name: 'openvip'})
                return
              } else if (res.data.vipCheckResult.needPayReason == 3) {
                this.$Message.error("在线发布职位数不足，请联系商务")
              }
            }
            //除了跳转 vip 页面的，别的一律定位到职位列表页面
            this.$router.replace({path: 'positionlist'})
          } else {
            this.$Message.error("保存失败,请稍后重试")
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    uploadCallback(response, file, fileList) {
      if (response.code == 2000) {
        this.codeUrl = response.data
      }
    },
    addLicense() {
      this.showAddLicenseDialog = true
    },
    getCompanyInfo() {
      api.statistics
        .getCompanyInfo()
        .then(res => {
          if (res.code == 2000) {
            if (res.data.length > 0) {
              this.companyInfo = res.data[res.data.length - 1]
            }
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    contactBD() {
      this.showQrCode = true
    }
  }
}
</script>

<style scoped>
.features {
  background: #F6F7FB;
  height: 100vh;
  padding: 60px 0 0 0;
  text-align: center;
}

.publishjob {
  font-size: 18px;
  color: black;
  margin-bottom: 10px;
  font-weight: bold
}

.top {
  width: 60%;
  display: flex;
  flex-direction: column;
  margin: auto;
  border: #EAECEE solid 1px;
  border-radius: 5px;
  padding: 10px;
}

.contentItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px
}

.content {
  width: 60%;
  display: flex;
  flex-direction: column;
  margin: 10px auto;
}

.contenttitle {
  width: 90px;
  flex: 0 0 auto;
  font-size: 14px;
  color: #101010;
  margin-left: 5px;
}

.label {
  width: fit-content;
  border: #EAECEE solid 1px;
  border-radius: 50px;
  font-size: 14px;
  color: #101010;
  margin-top: 7px;
  padding: 2px 10px;
  align-items: center;
  justify-content: center;
}

.address {
  margin: 15px auto;
  display: flex;
  flex-direction: column;
  width: 60%
}

.bottom {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 10px;
  margin-top: 10px
}

.bottombtn {
  color: black;
  background: white;
  border: #EAECEE 1px solid;
  font-size: 12px;
  padding: 5px 25px;
  border-radius: 20px
}

.child {
  position: absolute; /* 子元素绝对定位 */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* 居中 */
  width: 100%;
  text-align: center;
  color: #121212;
}

.tips-class {
  color: #33D0B2;
  border-bottom: solid #33D0B2 1px;
}

</style>
